export default __webpack_public_path__ + "static/media/tenant-fitbook.80ee78e5.png";